/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `budget_entry` - Wpis do budżetu
 * * `quiz` - Ukończony quiz
 * * `mission` - Ukończona misja dnia
 * * `complete_set` - Komplet okresu
 * * `follow_up` - Ocena zakupu po 7 dniach
 * * `manual` - Ręczny wpis
 * * `carry` - Przeniesienie z challenge
 */
export type ActivityTypeEnum = typeof ActivityTypeEnum[keyof typeof ActivityTypeEnum];


export const ActivityTypeEnum = {
  budget_entry: 'budget_entry',
  quiz: 'quiz',
  mission: 'mission',
  complete_set: 'complete_set',
  follow_up: 'follow_up',
  manual: 'manual',
  carry: 'carry',
} as const;
